import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { toast, Slide, ToastContainer } from 'react-toastify';
import _isFunction from 'lodash/isFunction';
import TEnvReader from '@tekion/tekion-base/readers/Env';
import 'react-toastify/dist/ReactToastify.css';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import NotificationContent from './NotificationContent';
import './reactToastify.overrides.scss';
export var TOASTER_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARN: 'warn'
};
var toaster = function toaster(type, message, options, heading, renderFooter, contentClassName, linesLimitForEllipsis, headingSize) {
  var content = /*#__PURE__*/React.createElement(NotificationContent, {
    message: message,
    contentClassName: contentClassName,
    type: type,
    heading: heading,
    renderFooter: renderFooter,
    linesLimitForEllipsis: linesLimitForEllipsis,
    headingSize: headingSize
  });
  if (TEnvReader.isExportMode()) {
    if (_isFunction(window.logMsgAtPuppeteer)) {
      window.logMsgAtPuppeteer("Suppressing Toaster In PDF Generation : ".concat(type, " -  ").concat(message));
    }
    return null;
  }
  return toast(content, options);
};
var dismissToast = function dismissToast(toastID) {
  toast.dismiss(toastID);
};
var NotificationWrapper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NotificationWrapper, _React$PureComponent);
  var _super = _createSuper(NotificationWrapper);
  function NotificationWrapper() {
    _classCallCheck(this, NotificationWrapper);
    return _super.apply(this, arguments);
  }
  _createClass(NotificationWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        autoClose = _this$props.autoClose,
        position = _this$props.position,
        className = _this$props.className;
      return /*#__PURE__*/React.createElement("div", {
        className: "notification-wrapper"
      }, /*#__PURE__*/React.createElement(ToastContainer, {
        transition: Slide,
        className: cx('toast-notification', className),
        toastClassName: "toast-notification-body",
        hideProgressBar: true,
        pauseOnHover: true,
        position: position,
        autoClose: autoClose,
        closeButton: false,
        closeOnClick: true
      }));
    }
  }]);
  return NotificationWrapper;
}(React.PureComponent);
NotificationWrapper.propTypes = {
  autoClose: PropTypes.number,
  position: PropTypes.string,
  className: PropTypes.string
};
NotificationWrapper.defaultProps = {
  autoClose: 3000,
  position: toast.POSITION.BOTTOM_CENTER,
  className: EMPTY_STRING
};
export default NotificationWrapper;
export { toaster, dismissToast };